import React from "react";
import { Box, Card, CardContent, Skeleton } from "@mui/material";

interface DashboardTilePlaceholderCardProps {
  type?: string;
  fillHeight?: boolean;
}

const DashboardTilePlaceholderCard: React.FC<
  DashboardTilePlaceholderCardProps
> = ({ type = "TextResponse", fillHeight = false }) => {
  const placeholderContent =
    type === "Graph" ? (
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 1,
          height: 180,
          pt: 2,
        }}
      >
        {[72, 112, 88, 144, 118].map((height, index) => (
          <Skeleton
            key={`${type}-${index}`}
            variant="rounded"
            animation="wave"
            sx={{
              flex: 1,
              height,
              transform: "none",
              borderRadius: 3,
            }}
          />
        ))}
      </Box>
    ) : type === "Table" ? (
      <Box sx={{ pt: 1 }}>
        <Skeleton
          variant="rounded"
          animation="wave"
          height={44}
          sx={{ borderRadius: 3, mb: 1.25 }}
        />
        {[0, 1, 2, 3].map((row) => (
          <Box
            key={`${type}-row-${row}`}
            sx={{
              display: "grid",
              gridTemplateColumns: "1.1fr 0.8fr 0.9fr",
              gap: 1,
              mb: 1,
            }}
          >
            <Skeleton
              variant="rounded"
              animation="wave"
              height={32}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              height={32}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              height={32}
              sx={{ borderRadius: 2 }}
            />
          </Box>
        ))}
      </Box>
    ) : (
      <Box sx={{ pt: 1 }}>
        <Skeleton variant="text" animation="wave" height={34} width="84%" />
        <Skeleton variant="text" animation="wave" height={34} width="93%" />
        <Skeleton variant="text" animation="wave" height={34} width="76%" />
        <Skeleton variant="text" animation="wave" height={34} width="88%" />
      </Box>
    );

  return (
    <Card
      elevation={0}
      sx={{
        height: fillHeight ? "100%" : "auto",
        borderRadius: 4,
        backgroundColor: "rgba(255,255,255,0.56)",
        border: "1px solid rgba(169,125,88,0.22)",
        backdropFilter: "blur(8px)",
        overflow: "hidden",
      }}
    >
      <CardContent
        sx={{
          height: fillHeight ? "100%" : "auto",
          padding: 2.5,
          "&:last-child": {
            paddingBottom: 2.5,
          },
        }}
      >
        {placeholderContent}
      </CardContent>
    </Card>
  );
};

export default DashboardTilePlaceholderCard;
